import React from "react";
import "../shirtWoman/style.css";

function shirtWoman() {
    return (
        <div>
            <h1>init</h1>
        </div>
    );
}
export default shirtWoman;
